import { $, $$, isMobileXs, isTablet, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, FreeMode } from 'swiper/modules';
import dataLayerPushSlider from '@utils/dataLayerPushSlider';

function init() {
  if (!$('[data-au-timeline]')) return;
  initSliders();
  isTablet.addEventListener('change', initSliders);
  isMobileXs.addEventListener('change', initSliders);
}

function initSliders() {
  $$('[data-au-timeline-slider]').forEach((slider) => {
    const itemsCount = slider.querySelectorAll('.au-timeline__item').length;
    const shouldCreate =
      itemsCount > 4 ||
      (itemsCount === 4 && isTablet.matches) ||
      ((itemsCount === 2 || itemsCount === 3) && isMobileXs.matches);

    if (shouldCreate) {
      createSwiper(slider);
    } else {
      destroySwiper(slider);
    }
  });
}

function createSwiper(slider) {
  if (slider._swiper) return;

  const swiper = new Swiper(slider, {
    modules: [Navigation, Scrollbar, A11y, FreeMode],
    ...sliderConfig,
    spaceBetween: 1,
    freeMode: false,
    on: {
      init() {
        updateFadesAndBg(this);
      },
      slideChange() {
        updateFadesAndBg(this);
      },
      setTranslate() {
        updateFadesAndBg(this);
      },
      reachBeginning() {
        updateFadesAndBg(this);
      },
      reachEnd() {
        updateFadesAndBg(this);
      },
      fromEdge() {
        updateFadesAndBg(this);
      },
      resize() {
        updateFadesAndBg(this);
      },
      update() {
        updateFadesAndBg(this);
      },
      touchEnd(swiper, event) {
        dataLayerPushSlider(swiper, event);
      },
    },
  });

  updateFadesAndBg(swiper);
  slider.classList.add('au-timeline__slider--active');
  slider._swiper = swiper;
}

function destroySwiper(slider) {
  if (!slider._swiper) {
    slider.classList.remove('au-timeline__slider--active');
    return;
  }

  slider._swiper.destroy(true, true);
  slider._swiper = null;
  slider.classList.remove('au-timeline__slider--active');
  slider.classList.remove('au-timeline__slider--fade-left', 'au-timeline__slider--fade-right');
}

function updateFadesAndBg(swiper) {
  const el = swiper.el;
  const controls = el.querySelector('[data-au-slider-controls]');

  if (swiper.isLocked) {
    el.classList.remove('au-timeline__slider--fade-left', 'au-timeline__slider--fade-right');
    if (controls) controls.classList.add('au-hide');
    swiper.wrapperEl.style.removeProperty('--timeline-total-width');
    return;
  }

  if (controls) controls.classList.remove('au-hide');
  el.classList.toggle('au-timeline__slider--fade-left', !swiper.isBeginning);
  el.classList.toggle('au-timeline__slider--fade-right', !swiper.isEnd);
  swiper.wrapperEl.style.setProperty('--timeline-total-width', `${swiper.virtualSize}px`);
}

export default { init };
